/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var interestFeesReferenceColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px'
}, {
  name: 'Общо лихви',
  render: function render(_ref) {
    var total_interests = _ref.total_interests,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interests"
    }, total_interests, " ", currency);
  }
}, {
  name: 'Общо лихви за забава',
  render: function render(_ref2) {
    var total_penalties = _ref2.total_penalties,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_penalties"
    }, total_penalties, " ", currency);
  }
}, {
  name: 'Общо такси',
  render: function render(_ref3) {
    var total_fees = _ref3.total_fees,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_fees"
    }, total_fees, " ", currency);
  }
}, {
  name: 'Общо',
  render: function render(_ref4) {
    var total = _ref4.total,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total"
    }, total, " ", currency);
  }
}, {
  name: 'Събрани лихви',
  render: function render(_ref5) {
    var total_paid_interests = _ref5.total_paid_interests,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_paid_interests"
    }, total_paid_interests, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Събрани лихви за забава',
  render: function render(_ref6) {
    var total_paid_penalties = _ref6.total_paid_penalties,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_paid_penalties"
    }, total_paid_penalties, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Събрани такси',
  render: function render(_ref7) {
    var total_paid_fees = _ref7.total_paid_fees,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_paid_fees"
    }, total_paid_fees, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо събрани',
  render: function render(_ref8) {
    var total_paid = _ref8.total_paid,
        currency = _ref8.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_paid"
    }, total_paid, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Просрочени лихви',
  render: function render(_ref9) {
    var total_late_interests = _ref9.total_late_interests,
        currency = _ref9.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests"
    }, total_late_interests, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Просрочени лихви за забава',
  render: function render(_ref10) {
    var total_late_penalties = _ref10.total_late_penalties,
        currency = _ref10.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_penalties"
    }, total_late_penalties, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Просрочени такси',
  render: function render(_ref11) {
    var total_late_fees = _ref11.total_late_fees,
        currency = _ref11.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees"
    }, total_late_fees, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо просрочени',
  render: function render(_ref12) {
    var total_late = _ref12.total_late,
        currency = _ref12.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late"
    }, total_late, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Очаквани лихви',
  render: function render(_ref13) {
    var total_future_interests = _ref13.total_future_interests,
        currency = _ref13.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_interests"
    }, total_future_interests, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Очаквани лихви за забава',
  render: function render(_ref14) {
    var total_future_penalties = _ref14.total_future_penalties,
        currency = _ref14.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_penalties"
    }, total_future_penalties, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Очаквани такси',
  render: function render(_ref15) {
    var total_future_fees = _ref15.total_future_fees,
        currency = _ref15.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_fees"
    }, total_future_fees, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо очаквани',
  render: function render(_ref16) {
    var total_future = _ref16.total_future,
        currency = _ref16.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future"
    }, total_future, " ", currency);
  },
  invisibleBelow: 3000
}];